import { createFileRoute } from '@tanstack/react-router'

import { ApiKeysCard } from '@/components/account/ApiKeysCard'
import { ConnectedAccountsCard } from '@/components/account/ConnectedAccountsCard'
import { DeleteAccountCard } from '@/components/account/DeleteAccountCard'
import { PasswordCard } from '@/components/account/PasswordCard'
import { ProfileCard } from '@/components/account/ProfileCard'
import { PageHeader } from '@/components/PageHeader'

export const Route = createFileRoute('/_authenticated/account')({
  component: AccountPage,
})

function AccountPage() {
  const { activeOrg } = Route.useRouteContext()
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Account"
        description="Manage your profile, password, and API keys."
      />
      <ProfileCard />
      <PasswordCard />
      <ConnectedAccountsCard />
      <ApiKeysCard activeOrg={activeOrg} />
      <DeleteAccountCard />
    </div>
  )
}
